import axios from 'axios';

const API_URL = '/api'; 

// 1. On crée l'instance et on l'exporte pour un usage générique (DashboardPage)
export const axiosInstance = axios.create({ baseURL: API_URL });

// Intercepteur pour le Token
axiosInstance.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// 2. On exporte l'instance sous le nom "api" pour correspondre au Dashboard
export const api = axiosInstance;

// 3. On garde votre objet existant pour le reste de l'application
export const apiClient = {
  login: async (u, p) => { const params=new URLSearchParams(); params.append('username',u); params.append('password',p); return (await axiosInstance.post('/auth/token', params)).data; },
  register: async (u, p) => (await axiosInstance.post('/auth/register', {username:u, password:p})).data,
  
  getPortfolios: async () => (await axiosInstance.get('/portfolio/')).data,
  getPortfolio: async (id) => (await axiosInstance.get(`/portfolio/${id}/summary`)).data,
  
  getStockAnalysis: async (symbol) => {
      try { return (await axiosInstance.get(`/analysis/${symbol}`)).data; } 
      catch (e) { console.error(e); return null; }
  },

  getScreener: async (f) => (await axiosInstance.get('/screener/search', { params: f })).data,
  getWatchlist: async () => { try { return (await axiosInstance.get('/watchlist/')).data; } catch { return []; } }
};

export default apiClient;
